module.exports = __webpack_public_path__ + "static/img/logo.6538ce00.png";